import React, { useContext } from "react";
import ConfigContext from "../context/config-context";
import ExtraFees from "./extra-fees/extra-fees";
import Plans from "./plans/plans";
import Quote from "./quote/quote";
import RegistrationFees from "./registration-fees/registration-fees";
import StructuralInspectionFees from "./structural-inspection-fees/structural-inspection-fees";
import TransferDuties from "./transfer-duties/transfer-duties";
import ExportContacts from "./export-contacts/export-contacts";
import RecentSettlements from "./recent-settlements/recent-settlements";

const Container = () => {
  const { forModule } = useContext(ConfigContext);

  let component = null;
  switch (forModule) {
    case "quote":
      component = <Quote />;
      break;
    case "plans":
      component = <Plans />;
      break;
    case "registration_fees":
      component = <RegistrationFees />;
      break;
    case "extra_fees":
      component = <ExtraFees />;
      break;
    case "transfer_duties":
      component = <TransferDuties />;
      break;
    case "structural_inspection_fees":
      component = <StructuralInspectionFees />;
      break;
    case "export_contacts":
      component = <ExportContacts />;
      break;
    case "recent_settlements":
      component = <RecentSettlements />;
      break;
    default:
      component = <Quote />;
      break;
  }
  return <>{component}</>;
};

export default Container;
